<template>
  <!-- <div class="container"> -->
  <div>
    <div class="content">
      <h2 v-if="!camera_error">{{ camera_message }}</h2>
      <div v-else class="camera-error">
        <h2>{{ camera_error }}</h2>
        <div class="btn btn-large" @click="openCapture">
          <i class="redo icon"></i>
          <span>Tentar novamente</span>
        </div>
      </div>
      <div v-show="!camera_error" class="foto">
        <input type="file" id="upload-file" name="image" ref="image" @change="onFileChange()" style="display:none;"/>
        <div class="camera-frame" ref="cameraFrame">
          <video ref="video" id="video" width="800" height="600" autoplay muted playsinline></video>
          <canvas ref="canvas" id="canvas" width="600" height="400"></canvas>
          <div id="border-photo"></div>
        </div>
        <img :src="img" alt="" class="camera-frame" ref="img">
        <!-- <button ref="snap" @click.prevent="openCapture()">Camera</button>
        <button ref="snap" @click.prevent="takePicture()">Captura</button>
        <button @click.stop="cancelPicture()">x</button> -->
      </div>
    </div>
    <div class="footer-btn">
      <div id="back-btn" class="btn btn-cancel" @click.prevent="$emit('backClicked', 'StartPage');">
        <i class="ui sign-out icon"></i>
        <span>Cancelar</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    ticket: Object
  },
  data() {
    return {
      msg: 'Seu atendimento foi finalizado. Por favor, aguarde na recepção.',
      lang: 'pt-BR',
      contador: 4,
      canvas: {},
      video: {},
      blob: {},
      img: '',
      stream: null,
      countdown_timer: null,
      camera_ready: false,
      camera_error: '',
      capture_finished: false,
      capture_attempt: 0,
      is_destroyed: false
    }
  },
  computed: {
    camera_message() {
      if (!this.camera_ready) return 'Preparando a câmera...';
      return 'Posicione seu rosto no círculo para a foto em ' + this.contador;
    }
  },
  mounted() {
    this.openCapture();
  },
  beforeDestroy() {
    this.is_destroyed = true;
    this.capture_attempt += 1;
    this.stopCapture();
  },
  methods: {
    async openCapture() {
        if (this.capture_finished) return;
        const attempt = ++this.capture_attempt;
        this.stopCapture();
        this.camera_error = '';
        this.camera_ready = false;
        this.contador = 4;
        this.$refs.canvas.style.display = 'none';
        this.$refs.cameraFrame.style.display = 'block';
        this.video = this.$refs.video;
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          this.camera_error = 'A câmera não está disponível neste navegador. Verifique se o totem está usando HTTPS.';
          return;
        }
        try {
          const stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: 'user' },
            audio: false
          });
          if (this.is_destroyed || attempt !== this.capture_attempt) {
            stream.getTracks().forEach(track => track.stop());
            return;
          }
          this.stream = stream;
          this.video.srcObject = this.stream;
          await this.video.play();
          this.camera_ready = true;
          this.startCountdown();
        } catch (err) {
          this.stopCapture();
          this.camera_error = err && err.name === 'NotAllowedError'
            ? 'Permissão de câmera negada. Libere a câmera no navegador e tente novamente.'
            : 'Não foi possível iniciar a câmera. Verifique a conexão do dispositivo e tente novamente.';
        }
    },
    startCountdown() {
      this.countdown_timer = setInterval(() => {
        this.contador -= 1;
        if (this.contador === 0) {
          clearInterval(this.countdown_timer);
          this.countdown_timer = null;
          this.takePicture();
        }
      }, 1000);
    },
    takePicture() {
      if (!this.camera_ready || !this.video.srcObject || this.capture_finished) {
        this.camera_error = 'A câmera ainda não está pronta. Tente novamente.';
        return;
      }
      // pegando elemento para setar a foto
      this.canvas = this.$refs.canvas;
      // setando a foto
      this.canvas.getContext("2d").drawImage(this.video, 0, 0, 600, 400);
      // convertendo para imagem
      var dataURL = this.canvas.toDataURL("image/png");
      // exibindo preview da imagem
      this.img = dataURL;
      //this.customer.image = pic;
      //var blob;
      this.blob = this.dataURItoBlob(dataURL);
      this.$refs.cameraFrame.style.display = 'none';
      this.$refs.img.style.display = 'block';
      this.capture_finished = true;
      this.stopCapture();
      this.$emit('setPhoto', this.img);
      this.$emit('buttonClicked', 'AgreementsList');
    },
    stopCapture() {
      if (this.countdown_timer) {
        clearInterval(this.countdown_timer);
        this.countdown_timer = null;
      }
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop());
        this.stream = null;
      }
      if (this.video && this.video.srcObject) {
        this.video.srcObject = null;
      }
      this.camera_ready = false;
    },
    dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(',')[0].indexOf('base64') >= 0)
          byteString = atob(dataURI.split(',')[1]);
      else
          byteString = unescape(dataURI.split(',')[1]);

      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], {type:mimeString});
    },
    onFileChange() {

    },
    speak(msg) {
      var app = this;
      var utterThis = new SpeechSynthesisUtterance(msg);
      var voices = speechSynthesis.getVoices();
      var voice_br = {};
      voices.map((value, i) => {
        if (value.lang == 'pt-BR') {
        }
      });
      window.speechSynthesis.speak(utterThis);
    },
    falar() {
      let SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
      let recognition = SpeechRecognition ? new SpeechRecognition() : false
      recognition.lang = this.lang;
      recognition.interimResults = true;
    }
  }
}
</script>
<style scoped>
@keyframes spin {
  to { transform: rotate(360deg); }
}
.container {
  position: absolute;
  top: 50%;
  left: 25%;
  width: 100%;
  margin: -24% 0 0 -25%;
}
h2 {
  font-size: 60px;
  color: #fff;
  text-align: center;
}
p {
  font-size: 36px;
  color: #fff;
  font-family: 'Source Sans Light';
  font-weight: bold;
}
.camera-frame {
  width: 700px;
  margin: 0 auto;
  height: 525px;
}
#video {
  width: 100%;
  height: 100%;
}
#canvas {
  position: absolute;
  right: 20px;
}
.foto img {
  display: none;
  width: 700px;
  margin: 0 auto;
  height: 525px;
}
.camera-error {
  text-align: center;
}
.camera-error h2 {
  max-width: 900px;
  margin: 80px auto 30px;
  font-size: 42px;
}
.camera-error .btn-large {
  width: 300px;
  height: 70px;
  margin: 0 auto;
  justify-content: center;
}
#border-photo {
  border: 10px solid limegreen;
  border-style: dotted;
  position: absolute;
  width: 418px;
  height: 60%;
  top: 142px;
  border-radius: 500px;
  left: 39%;
  animation: spin 1s linear infinite;
}
/* .footer-btn {
  position: fixed;
  bottom: 16px;
  padding: 0px 20px;
} */
/* .btn {
  display: flex;
  width: 180px;
  height: 60px;
  align-items: center;
  font-size: 26px;
  border-radius: 500px;
  background-color: rgb(255, 255, 255);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 1px 2px rgba(0, 0, 0, 0.23);
  cursor: pointer;
}
.btn span {
  width: inherit;
}
.btn-cancel span {
  position: absolute;
  width: fit-content;
  right: 46px;
}
.btn-cancel i {
  position: absolute;
  left: 34px;
  top: 14px;
  transform: rotate(180deg);
} */
</style>



// WEBPACK FOOTER //
// src/components/TakePicture.vue